import { FC, useMemo } from 'react'
import styles from 'components/features/pfm/OpportunityReviewCompose/OpportunityReviewCompose.styl'
import { ComposeMount } from 'components/features/socialFeed/ComposeMount/ComposeMount'
import { ComposeFocusable } from 'components/features/socialFeed/ComposeFocusable/ComposeFocusable'
import { ComposeInputController } from 'components/features/socialFeed/ComposeInputController/ComposeInputController'
import { ComposeAttach } from 'components/features/socialFeed/ComposeAttach/ComposeAttach'
import { SocialInsightUid } from 'interfaces/socialInsights'
import { getCreateReviewComposeId } from 'helpers/composeHelpers'
import { ComposeErrors } from 'components/features/socialFeed/ComposeErrors/ComposeErrors'
import { CommentUid } from 'interfaces/feed'
import { useComposeState } from 'helpers/hookHelpers'

type OpportunityReviewComposeProps =
  & {
    socialInsightUid: SocialInsightUid
    commentUid?: CommentUid
  }

export const OpportunityReviewCompose: FC<OpportunityReviewComposeProps> = (props) => {
  const { socialInsightUid, commentUid } = props

  const composeId = getCreateReviewComposeId(socialInsightUid)
  const withComposeId = useMemo(() => ({ composeId }), [composeId])
  const { id } = useComposeState(composeId, { id: null })

  const isCreated = id !== null

  return (
    <div className={ styles.opportunityReviewCompose }>
      <ComposeMount
        placeholder='Start typing'
        postUid={ socialInsightUid }
        commentUid={ commentUid }
        isEdit={ !!commentUid }
        isOpportunityReview
        { ...withComposeId }
      >
        { isCreated && (
          <ComposeFocusable { ...withComposeId }>
            <div className={ styles.middle }>
              <div className={ styles.input }>
                <ComposeInputController { ...withComposeId } />
              </div>
              <div className={ styles.attach }>
                <ComposeAttach { ...withComposeId } />
              </div>
            </div>
            <div className={ styles.errors }>
              <ComposeErrors { ...withComposeId } />
            </div>
          </ComposeFocusable>
        )}
      </ComposeMount>
    </div>
  )
}
